/**
 * @file パスワードリセット（本人確認）フォームの入力状態を管理するステート
 *
 * パスワードリセット画面の本人確認ステップで、
 * 姓名・生年月日・電話番号・ISP番号の入力値を保持する。
 * SMS認証・ワンタイムパスワード検証の際にこれらの値がAPIリクエストに使用される。
 * セッションストレージに永続化される。
 */
import { atom } from 'recoil';
import persistAtom from './recoilPersist';

/** パスワードリセット（本人確認）フォームの入力値型 */
type PasswordResetForm = {
  /** 姓 */
  lsName: string;
  /** 名 */
  flName: string;
  /** 生年月日（年） */
  birthDateYear: string;
  /** 生年月日（月） */
  birthDateMonth: string;
  /** 生年月日（日） */
  birthDateDay: string;
  /** 連絡先電話番号 */
  phoneNumber: string;
  /** ISP（お客さま）番号 */
  ispNumber: string;
};
export type { PasswordResetForm };

const passwordResetFormState = atom<PasswordResetForm>({
  key: 'passwordResetFormState',
  default: {
    lsName: '',
    flName: '',
    birthDateYear: '',
    birthDateMonth: '',
    birthDateDay: '',
    phoneNumber: '',
    ispNumber: '',
  },
  effects_UNSTABLE: [persistAtom],
});
export { passwordResetFormState };
